import { Alert } from '@mui/material';
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import PendingOutlinedIcon from "@mui/icons-material/PendingOutlined";
import { SvgIconComponent } from '@mui/icons-material';

type StatusType = "Not Final" | "Final" | string;

interface StatusConfig {
  severity: "info" | "success" | "warning" | "error";
  icon: SvgIconComponent;
  borderColor: string;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  "Not Final": {
    severity: "info",
    icon: PendingOutlinedIcon,
    borderColor: "rgba(33, 150, 243, 0.5)",
  },
  "Final": {
    severity: "success",
    icon: PaidOutlinedIcon,
    borderColor: "rgba(46, 125, 50, 0.5)",
  },
};

const DEFAULT_CONFIG: StatusConfig = {
  severity: "info",
  icon: PendingOutlinedIcon,
  borderColor: "rgba(158, 158, 158, 0.5)",
};

interface ReceiptStatusProps {
  status: StatusType;
}

export const ReceiptStatus = ({ status }: ReceiptStatusProps) => {
  const config = STATUS_CONFIG[status] || DEFAULT_CONFIG;
  const IconComponent = config.icon;

  return (
    <div className="AlertItems">
    <Alert
      icon={<IconComponent />}
      severity={config.severity}
      sx={{
        border: `1px solid ${config.borderColor}`,
        padding: '0px 5px',
        display: 'inline-flex',
      }}
    >
      {status
          .split(' ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ') || ''}
    </Alert>
    </div>
  );
};
